<template>
  <BaseScreen v-bind="screen">
    <MyAccounts
      :items="accounts"
      @find="goToFindAccountScreen"
      @add="goToAddAccountScreen"
    />
    <BaseTooltip
      v-bind="tooltip"
      class="screen__tooltip"
      slot="title"
    />
    <ModalNote
      v-if="isNoteModalVisible"
      class="screen__overlay"
      @close="hideNoteModal"
    />
  </BaseScreen>
</template>

<script>
import { mapState } from 'vuex';
import CONSTANTS from '@/helpers/constants';

import screenMixin from '@/mixins/screen';
import BaseTooltip from '@/components/BaseTooltip.vue';
import MyAccounts from '@/components/MyAccounts.vue';
import ModalNote from '@/components/ModalNote.vue';

export default {
  name: 'PersonalAccountsScreen',
  mixins: [screenMixin],
  components: {
    BaseTooltip,
    MyAccounts,
    ModalNote,
  },
  data() {
    return {
      isNoteModalVisible: false,
    };
  },
  computed: {
    ...mapState('personal', [
      'accounts',
    ]),
    titleText() {
      return this.$t('titles.accountManagement');
    },
    screenCase() {
      if (this.isNoteModalVisible) {
        return CONSTANTS.STEP_MODAL;
      }
      return CONSTANTS.STEP_ACCOUNTS;
    },
    tooltip() {
      return {
        action: this.showNoteModal,
      };
    },
  },
  created() {
    this.initActions([
      [CONSTANTS.ACTION_ADD_ACCOUNT, this.goToAddAccountScreen],
      [CONSTANTS.ACTION_FIND_ACCOUNT, this.goToFindAccountScreen],
      [CONSTANTS.ACTION_SHOW_MODAL, this.showNoteModal],
      [CONSTANTS.ACTION_CLOSE, this.hideNoteModal],
    ]);
  },
  methods: {
    showNoteModal() {
      this.isNoteModalVisible = true;
    },
    hideNoteModal() {
      this.isNoteModalVisible = false;
    },
    goToFindAccountScreen() {
      this.$router.push(this.$router.options.paths.personalFindAccount);
    },
    goToAddAccountScreen() {
      this.$router.push(this.$router.options.paths.personalAddAccount);
    },
  },
};
</script>
